import React from 'react';
import { Route, Routes } from 'react-router-dom';
import { featureNestedRoutes } from '../../app-routes';
import { EngageSettingsNavigator } from './EngageSettingsNavigator';
import { FeatureSurfaceProvider } from '../feature-setup/FeatureSurfaceProvider';
import { EditAutomationTemplate } from '../feature-setup/edit-automation-template';
import { EditSegmentPage } from '../feature-setup/edit-segment';

export const EngageSetup: React.FC = () => {
  // Routes are relative to /dashboard/engage/* where this component is rendered
  return (
    <FeatureSurfaceProvider feature="engage">
      <div className="space-y-6">
        <Routes>
          <Route path={featureNestedRoutes.AUTOMATIONS_EDIT} element={<EditAutomationTemplate />} />
          <Route path={featureNestedRoutes.SEGMENTS_NEW} element={<EditSegmentPage />} />
          <Route path={featureNestedRoutes.SEGMENTS_EDIT} element={<EditSegmentPage />} />
          <Route path=":tab?" element={<EngageSettingsNavigator />} />
        </Routes>
      </div>
    </FeatureSurfaceProvider>
  );
};
